import { BATCH_LABELS_WS_KEYS } from "@wingspanhq/payments/dist/lib/constants";
import { Batch } from "@wingspanhq/wingspan-api-sdk";

// The payablesImport listener writes the v1 label keys into `Batch.metadata`.
export const selectorIsImportBatchUploadInProgress = (batch?: Batch): boolean =>
  !!batch?.metadata?.[BATCH_LABELS_WS_KEYS.flatfileBatchId] &&
  !!batch?.metadata?.[BATCH_LABELS_WS_KEYS.flatfileJobId] &&
  !batch?.metadata?.[BATCH_LABELS_WS_KEYS.uploadFinishedAt];
